import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_10: FaireProductEntity = {
  token: "atc_updated_fs_rec_10",
  type: "product",
  name: "Orange Mushroom Table Lamp",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3243cb6a20b393eafd7f072eeae9a12de0307d5c7ca10feffa97e6420c009974.webp",
  priceDollars: 68,
  msrpDollars: 85,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
